import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomerService } from '../../services/customer.service';
import { ErrorService } from '../../services/error.service';
import { FileService } from '../../services/file.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
	selector: 'app-attachment-list',
	templateUrl: './attachment-list.component.html',
	styleUrls: ['./attachment-list.component.scss']
})
export class AttachmentListComponent {
	@Input() public access: number;
	public fileExtensionRegex = /(?:\.([^.]+))?$/;
	@Input() public podAttachments: any[];
	@Input() public regularAttachments: any[];
	@Output() public remove: EventEmitter<any> = new EventEmitter<any>();
	@Input() public workOrder: any;
	@Input() public user: any;

	constructor(private _dialog: MatDialog,
				private _fileService: FileService,
				private _errorService: ErrorService,
				private _customerService: CustomerService) {
	}

	openFile(file): void {
		const fileType = this.fileExtensionRegex.exec(file.fileName)[1];
		const selectedCustomer = this._customerService.getSelectedCustomer();
		const convertTo = fileType === 'pdf' ? fileType : selectedCustomer ? selectedCustomer.defaultImageConversion : 'NO_CONVERSION';
		this._fileService.getFile(file.id, convertTo).subscribe(
			(response) => {
				// Success
				// We get base64 but need a blob so convert it, using mime-types library to
				// guess the mime type based on file extension - This is not fool proof as file
				// extensions can be spoofed
				const blob = this._fileService.convertToBlob(response);
				// If IE or Edge
				if ((window.navigator as any).msSaveBlob) {
					return (window.navigator as any).msSaveBlob(blob, response.fileName);
				}
				const reader: any = new FileReader();
				reader.onload = (e) => {
					let content;
					if (reader.result.includes('image')) {
						content = new Image();
						content.src = reader.result;
					}
					const newTab = window.open();
					if (newTab) {
						newTab.document.write(content ? content.outerHTML : '<iframe src="' + reader.result + '" frameborder="0" class="no-border-full-screen" allowfullscreen></iframe>');
					} else {
						this._errorService.error({
							detailedMsg: 'Pop-up Blocker is enabled! Please add this site to your exception list.',
							generalMsg: 'Pop-up blocked!'
						}, null, 'modal');
					}
				};
				reader.readAsDataURL(blob);
			},
			(error) => {
				this._errorService.error(error, 'openFile Failed', 'modal');
			}
		);
	}

	processAttachments(): void {
		this.regularAttachments = this.workOrder.attachments.filter((a) => a.fileCategory !== 'POD_IMAGE');
		this.podAttachments = this.workOrder.attachments.filter((a) => a.fileCategory === 'POD_IMAGE');
	}

	removeAttachment(file): void {
		if (!this.workOrder) {
			this.remove.emit(file);
		} else {
			const dialogRef = this._dialog.open(ModalComponent, {
				data: {
					title: 'Warning',
					message: 'You are about to delete an attachment.  Would you like to proceed?',
					showCancel: true,
					cancelText: 'No',
					okText: 'Yes'
				}
			});
			dialogRef.afterClosed().subscribe((result) => {
				if (result) {
					this._fileService.deleteFile(file.id).subscribe(() => {
						const idx = this.workOrder.attachments.indexOf(file);
						if (idx !== -1) {
							this.workOrder.attachments.splice(idx, 1);
							this.processAttachments();
						}
					}, error => {
						this._errorService.error(error, 'deleteFile Failed', 'modal');
					});
				} else {
					return false;
				}
			});
		}
	}
}
